import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconAssetPlaylistStyle0 = gravityIconIndividualCss;

const GravityIconAssetPlaylist = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '4abb10447d7c32ae2b8a3f0b918fe4092976ea46', color: this.color, size: this.size }, h("svg", { key: '444da8cfea7450bededf9d96261b0d994aa74452', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'c1f0d252223b48da0496fdbc8cbeb2d4c0ec334f', d: "m2.46 8.08 3.29-2.16a.3.3 0 0 0-.01-.52l-3.28-2a.3.3 0 0 0-.46.25v4.18a.3.3 0 0 0 .46.25Zm6.04 2.17a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-10ZM8 5.5a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5V6a.5.5 0 0 1-.5.5h-10A.5.5 0 0 1 8 6v-.5Zm.5 10a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V16a.5.5 0 0 0-.5-.5h-10Z", fill: "currentColor" }))));
    }
};
GravityIconAssetPlaylist.style = GravityIconAssetPlaylistStyle0;

export { GravityIconAssetPlaylist as gravity_icon_asset_playlist };

//# sourceMappingURL=gravity-icon-asset-playlist.entry.js.map